// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__30Guu","bigColWidth":"Table_bigColWidth__5Ggj1","biggerColWidth":"Table_biggerColWidth__2yi6n","row":"Table_row__1hdCs","col":"Table_col__ky30f"};